export const FEEDBACK_FORM = `https://docs.google.com/forms/d/e/
1FAIpQLSd0xLzKrKDlfZjOd0ILQ4Rgoo36FQT9nBNNXj4HbzWq2dYVjA/viewform?usp=pp_url`;
